import FiveTemplate from '~/entities/projects/ui/templates/FiveTemplate.vue'
import FourTemplate from '~/entities/projects/ui/templates/FourTemplate.vue'
import OneTemplate from '~/entities/projects/ui/templates/OneTemplate.vue'
import ThreeTemplate from '~/entities/projects/ui/templates/ThreeTemplate.vue'
import TwoTemplate from '~/entities/projects/ui/templates/TwoTemplate.vue'
import WithoutTemplate from '~/entities/projects/ui/templates/WithoutTemplate.vue'
import { permissions } from '~/shared/lib'

export const PROJECT_LOGO_ASPECT_RATIO = 415 / 136

/** Длина названия для карточки в списке проектов (1 строка, md — самый узкий заголовок). */
export const PROJECT_NAME_MAX_LENGTH = 21

export const KVEST_TEXT_LOGO_SRC = '/text-logo-dark.svg'

export enum templateId {
  without_template = '0',
  one_template = '1',
  two_template = '2',
  three_template = '3',
  four_template = '4',
  five_template = '5',
}

export const templateComponents = {
  0: WithoutTemplate,
  1: OneTemplate,
  2: TwoTemplate,
  3: ThreeTemplate,
  4: FourTemplate,
  5: FiveTemplate,
}

export const editTemplateRoutes = {
  0: permissions.PROJECTS.WORKSPACE.ABOUT.TEMPLATES.NO_TEMPLATE.EDIT.PERMISSION,
  1: permissions.PROJECTS.WORKSPACE.ABOUT.TEMPLATES.ONE_TEMPLATE.EDIT.PERMISSION,
  2: permissions.PROJECTS.WORKSPACE.ABOUT.TEMPLATES.TWO_TEMPLATE.EDIT.PERMISSION,
  3: permissions.PROJECTS.WORKSPACE.ABOUT.TEMPLATES.THREE_TEMPLATE.EDIT.PERMISSION,
  4: permissions.PROJECTS.WORKSPACE.ABOUT.TEMPLATES.FOUR_TEMPLATE.EDIT.PERMISSION,
  5: permissions.PROJECTS.WORKSPACE.ABOUT.TEMPLATES.FIVE_TEMPLATE.EDIT.PERMISSION,
}
